import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    pId: '',
    password:'',
    badgeObject:{},
    title: 'My Custom Title',
    jwskToken: null,
    studentId: '',
    parentName: '',
    studentName: '',
    pushToken: 'none',
    accessToken: null,
    hangerId: '',
    dateCreated: null,
    links: [
      'http1',
      'http2',
      'http3'
    ],
    itemsInCart: [
      
    ],
    message: "Hello from Vuex",
    count: 0,
    userName: "",
    mobilePhone: "",
    emailString: "",
    firstName: "",
    lastName: "",
    companyName: "",
    loginUUID: "",
    dob: Date,
    imageUri: {
      uri: 'https://facebook.github.io/react-native/docs/assets/favicon.png'
      },
  },
  mutations: {
    AUTHENTICATE(state, { token, user, comp,mobile,email,first,last,loguuid,dob,pId,password,dateCreated,hangerId}) {

      state.jwtToken =  token;
      state.userName = user;
      state.companyName = comp;
      state.mobilePhone = mobile;
      state.emailString = email;
      state.firstName = first;
      state.lastName = last;
      state.loginUUID = loguuid;
      state.dob = dob;
      state.pId = pId;
      state.password = password;
      state.dateCreated = dateCreated;
      state.hangerId = hangerId;
    
 },

 NEW_STUDENT(state, { studentId, parentName, studentName,pushToken,companyName}) {

  state.studentId =  studentId;
  state.parentName = parentName;
  state.studentName = studentName;
  state.pushToken = pushToken;
  state.companyName = companyName;

  },
  },
  actions: {

    addAuth({ commit },payload) {

      commit('AUTHENTICATE',
        payload);

    },
    addStudent({ commit },payload) {

      commit('NEW_STUDENT',
        payload);

    },

  },
  modules: {
  }
})
